import React, { useEffect, useState } from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { Row, Card, Form, Input, Col, Radio, Space, Spin, Button, Typography } from 'antd'
import InputMask from 'react-input-mask'
import { EmptyHeaderHero, SEO } from './components'
import { checkSecurityQuestions, getSecurityQuestions, retrievePolicyUser, updateEmail, verifyLogin, checkGWAccount, getWebsiteMaintenanceStatus } from '../services'
import { useWindowSize, getDomain } from '../utils'
import Router from 'next/router'
import { checkSelfService } from '../services/Api'
import ForgotEmailStyle from '../../styles/ForgotEmail.module.css'

const { Text } = Typography
const antIcon = <LoadingOutlined spin style={{ fontSize: 24 }} />

const getEnvSite = () => {
  if (typeof window !== 'undefined') {    
    switch (window.location.hostname) {
      case 'localhost':
        return 'https://getquotestg.cure.com/ServiceInterruption.aspx'
      case 'staging.cure.com':
        return 'https://getquotestg.cure.com/ServiceInterruption.aspx'
      case 'prepublish.cure.com':
        return 'https://getquoteprep.cure.com/ServiceInterruption.aspx'
      default:
        return 'https://getquote.cure.com/ServiceInterruption.aspx'
    }
  }
}

const ForgotEmail = () => {
  const [lastName, setLastName] = useState('')
  const [dateOfBirth, setDateOfBirth] = useState('')
  const [zipCode, setZipCode] = useState('')
  const [retrievedPolicyUser, setRetrievedPolicyUser] = useState(null)
  const [message, setMessage] = useState(null)
  const [emailConfirmationMessage, setEmailConfirmationMessage] = useState(null)
  const [changeCurrentEmail, setChangeCurrentEmail] = useState(false)
  const [confirmCurrentEmail, setConfirmCurrentEmail] = useState(null)
  const [securityAnswer, setSecurityAnswer] = useState(null)
  const [filteredSecurityQuestions, setFilteredSecurityQuestions] = useState(null)
  const [selectedPwdOption, setSelectedPwdOption] = useState(null)
  const [securityQuestionMessage, setSecurityQuestionMessage] = useState(null)
  const [newEmailAddress, setNewEmailAddress] = useState('')
  const [confirmNewEmailAddress, setConfirmNewEmailAddress] = useState('')
  const [password, setPassword] = useState('')
  const [loginApiResponseMessage, setLoginApiResponseMessage] = useState()
  const [showLogin, setShowLogin] = useState(null)
  const [showSpinner, setShowSpinner] = useState(false)

  const windowSize = useWindowSize()
  const isMobile = windowSize.width > 1024

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  const handleSubmit = async () => {
    setMessage(null)
    setShowSpinner(true)
    const response = await retrievePolicyUser(lastName, dateOfBirth, zipCode, 'forgot-email')
    if (response && response.data && response.data.Result === 'Success') { //user found in tblPolicyUsers

      const selfServiceResponse = await checkSelfService(response?.data?.User?.Policy_Number, response?.data?.User?.Env) // Check self service table if policy is blocked from logging in
      if (selfServiceResponse?.data?.Result != null) {
        setMessage(selfServiceResponse?.data?.Result)
      }
      else {
        setRetrievedPolicyUser(response.data)
        setMessage(response.data.Result)
      }
    }
    else if (response && response.data && response.data.Result === "Error") { //some error
      setMessage("An error occured")
    }
    else if (response && response.data && response.data.Result === "Inactive") { //some error
      setMessage(response.data.Result)
    }
    else if (response && response.data && response.data.Result !== 'Success') { //user not found in tblPolicyUsers, check GW table
      const res = await checkGWAccount({ LastName: lastName, DOB: dateOfBirth })

      if (res && res.data && res.data.Result === 'Success') {
        const selfServiceResponse = await checkSelfService(res.data?.Account?.Policy_Number, res.data?.Env?.Policy_Number) // Check self service table if policy is blocked from logging in
        if (selfServiceResponse?.data?.Result != null) {
          setMessage(selfServiceResponse?.data?.Result)
        }
        else {
          if (res.data.Account.Converted === "no") {
            Router.push(`/my-account/update?verifiedUser=${res.data.Account.EmailAddress}`);
          }
        }
      } 
      else if (res && res.data && res.data.Result === "Error") { //some error
        setMessage("An error occured")
      } 
      else if (res && res.data && res.data.Result !== 'Success') {
        setMessage(res.data.Result);
      }
    }
    setShowSpinner(false)
  }

  const setResetPassword = () => {
    localStorage.setItem("retrievedPolicyUser", JSON.stringify(retrievedPolicyUser))
    const url = `/my-account/forgot-password`
    window.location = url
  }

  const validatePassword = password => {
    const isValidLength = /^(?=.*[0-9])(?=.*[A-Z]).{5,}$/
    let response = false
    if (password.length === 0) {
      response = true
    } else if (password.length > 0) {
      if (!isValidLength.test(password)) {
        response = true
      } else {
        response = false
      }
    }
    return response
  }

  const loginWithCurrentEmail = async () => {
    setMessage(null)
    setLoginApiResponseMessage(null)
    setShowSpinner(true)
    const validationResponse = validatePassword(password)
    if (!validationResponse) {
      const emailAddress = retrievedPolicyUser.User.EmailAddress
      const response = await verifyLogin(emailAddress, password, 'login')
      if (response && response.data) {
        setPassword('')
        const { Result, Tkn } = response.data
        console.log(Result)
        setLoginApiResponseMessage(Result)
        if (Result === 'Success') {
          const url = `https://${getDomain('account')}/home?tkn=${Tkn}`
          window.location = url
        } else {
          Router.push(`/my-account/update?verifiedUser=${emailAddress}`);
        }
      }
    } else {
      setLoginApiResponseMessage('Not Found')
    }
    setShowSpinner(false)
  }

  const loginWithNewEmail = async () => {
    setMessage(null)
    setLoginApiResponseMessage(null)
    setShowSpinner(true)
    const validationResponse = validatePassword(password)
    if (!validationResponse) {
      const response = await verifyLogin(newEmailAddress, password, 'login')
      if (response && response.data) {
        setPassword('')
        const { Result, Tkn } = response.data
        setLoginApiResponseMessage(Result)
        if (Result === 'Success') {
          const url = `https://${getDomain('account')}/home?tkn=${Tkn}`
          window.location = url
        }
      }
    } else {
      setLoginApiResponseMessage('Not Found')
    }
    setShowSpinner(false)
  }

  const handleZipCodeChange = event => {
    const value = event.target.value.replace(/\D/g, '')
    setZipCode(value)
  }

  useEffect(() => {
    async function fetchWebsiteMaintainence() {
      const websiteStatusResponse = await getWebsiteMaintenanceStatus()
      if (websiteStatusResponse && websiteStatusResponse.data) {
        const status = websiteStatusResponse.data
        if (
          status.Result == "Active" && status?.Pages.includes("MyAccountLogin")
          && !status.AllowAccessPages.includes("MyAccountLogin")
        ) {
          window.location.href = getEnvSite()
        }
      }
    }
    fetchWebsiteMaintainence()

    async function fetchSecurityQuestions() {
      const securityQuestions = await getSecurityQuestions()
      if (changeCurrentEmail && retrievedPolicyUser && securityQuestions.data) {
        const questions = securityQuestions.data.filter(({ Code }) => {
          return (
            retrievedPolicyUser.User.SecurityQuestion1 === Code ||
            retrievedPolicyUser.User.SecurityQuestion2 === Code ||
            retrievedPolicyUser.User.SecurityQuestion3 === Code
          )
        })
        setFilteredSecurityQuestions(questions)
      }
    }
    if (changeCurrentEmail && retrievedPolicyUser) {
      fetchSecurityQuestions()
    }
  }, [changeCurrentEmail, retrievedPolicyUser])

  const handleChangeEmail = async () => {
    setShowSpinner(true)
    if (securityAnswer && securityAnswer.length > 0) {
      if (selectedPwdOption) {
        const securityQuestionList = filteredSecurityQuestions.map(question => ({
          Code: question.Code,
          Answer: question.Code === selectedPwdOption ? securityAnswer : ''
        }))
        const response = await checkSecurityQuestions({
          PolicyNumber: retrievedPolicyUser.User.Policy_Number,
          ZipCode: retrievedPolicyUser.User.Zip,
          Questions: securityQuestionList
        })

        const isValid = response.data.Questions.filter(question => question.Match === true)


        if (isValid && isValid.length > 0) {
          setConfirmCurrentEmail(true)
        } else {
          setSecurityQuestionMessage('Invalid Answer. Try again.')
        }
      }
    }
    scrollToTop()
    setShowSpinner(false)
  }

  const handleRadioClick = event => {
    const selectedSecurityQuestion = event.target.value
    setSelectedPwdOption(selectedSecurityQuestion)
  }

  const validateEmailSubmission = () => {
    const regEx = /\S+@\S+\.\S+/
    let validationResponse = null
    if (newEmailAddress.length > 0 && regEx.test(newEmailAddress)) {
      validationResponse = null
    } else {
      validationResponse = 'Email Address is invalid'
    }
    let pwdValidationResponse = null
    if (confirmNewEmailAddress.length > 0 && regEx.test(confirmNewEmailAddress)) {
      pwdValidationResponse = null
    } else {
      pwdValidationResponse = 'Email Address is invalid'
    }
    return {
      email: validationResponse,
      confirmEmail: pwdValidationResponse
    }
  }

  const handleEmailConfirmation = async () => {
    setShowSpinner(true)
    setShowLogin(false)
    const { email, confirmEmail } = validateEmailSubmission()
    if (!email && !confirmEmail) {
      if (newEmailAddress === confirmNewEmailAddress) {
        const response = await updateEmail({
          PolicyNumber: retrievedPolicyUser.User.Policy_Number,
          ZipCode: retrievedPolicyUser.User.Zip,
          EmailAddress: newEmailAddress
        })
        setShowLogin(true)
        setEmailConfirmationMessage(response.data.Result)
      } else {
        setEmailConfirmationMessage('Email Not Matching')
      }
    }
    setShowSpinner(false)
  }

  const validateEmailInputs = () => {
    if (lastName.length === 0 || dateOfBirth.length === 0 || zipCode.length === 0 || zipCode.length < 5) {
      return true
    }
    if (new Date(dateOfBirth).toString() === 'Invalid Date') {
      return true
    }
    return false
  }

  const validateEmailConfirmation = () => {
    let response = false
    if (newEmailAddress.length === 0 || confirmNewEmailAddress.length === 0) {
      response = true
    } else if (newEmailAddress.length > 0 && confirmNewEmailAddress.length > 0) {
      if (newEmailAddress === confirmNewEmailAddress) {
        const regEx = /\S+@\S+\.\S+/
        if (newEmailAddress.length > 0 && regEx.test(newEmailAddress)) {
          response = false
        } else {
          response = true
        }
        if (confirmNewEmailAddress.length > 0 && regEx.test(confirmNewEmailAddress)) {
          response = false
        } else {
          response = true
        }
      } else {
        response = true
      }
    }
    return response
  }

  const handleKeyDown = event => {
    if (event.key === 'Enter' && !validateEmailInputs()) {
      handleSubmit()
    }
  }

  const handleLoginKeyDown = event => {
    if (event.key === 'Enter') {
      loginWithCurrentEmail()
    }
  }

  const handleChangeEmailKeyDown = event => {
    if (event.key === 'Enter' && !validateEmailConfirmation()) {
      handleEmailConfirmation()
    }
  }

  const disableSubmitButton = !selectedPwdOption || !securityAnswer

  const handleSecurityKeyDown = event => {
    if (event.key === 'Enter' && !disableSubmitButton) {
      handleChangeEmail()
    }
  }

  const handleLoginWithUpdatedEmailKeyDown = event => {
    if (event.key === 'Enter') {
      loginWithNewEmail()
    }
  }

  return (
    <>
      <SEO
        title={"Create an Account | CURE Auto Insurance"} 
        description={"Forgot your registered email? Retrieve your CURE auto insurance account email in a few simple steps."} 
        url={"/my-account/forgot-email"}
      />
      <EmptyHeaderHero title="Trouble Logging In?" />
      <div className={`${ForgotEmailStyle["forgot-email-screen"]}`}>
        <Row>
          <Card className={`${ForgotEmailStyle["forgot-email-card"]}`}>
            <div>
              {!changeCurrentEmail && <h5>Let&apos;s find your account.</h5>}
              {changeCurrentEmail && !confirmCurrentEmail && (
                <h5 className={`${ForgotEmailStyle["margin-bottom-0"]}`}>Change your username (email).</h5>
              )}
              {!retrievedPolicyUser && (
                <Col>
                  <Row>
                    <Col
                      className={`${ForgotEmailStyle["account-margin"]}`}
                      lg={{ span: 6 }}
                      md={{ span: 8 }}
                      xl={{ span: 6 }}
                      xs={{ span: 24 }}
                    >
                      <Form.Item>
                        <Input
                          autoComplete="off"
                          className={`${ForgotEmailStyle["input-text"]}`}
                          onChange={event => setLastName(event.target.value)}
                          onKeyDown={handleKeyDown}
                          placeholder="Last Name*"
                          value={lastName}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className={`${ForgotEmailStyle["account-margin"]}`}
                      lg={{ span: 6 }}
                      md={{ span: 8 }}
                      xl={{ span: 6 }}
                      xs={{ span: 24 }}
                    >
                      <Form.Item>
                        <InputMask
                          className={`${ForgotEmailStyle["dob"]}`}
                          mask="99/99/9999"
                          onChange={event => setDateOfBirth(event.target.value)}
                          onKeyDown={handleKeyDown}
                          placeholder="DOB (mm/dd/yyyy)*"
                          value={dateOfBirth}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className={`${ForgotEmailStyle["account-margin"]}`}
                      lg={{ span: 6 }}
                      md={{ span: 8 }}
                      xl={{ span: 6 }}
                      xs={{ span: 24 }}
                    >
                      <Form.Item>
                        <Input
                          autoComplete="off"
                          className={`${ForgotEmailStyle["input-text"]}`}
                          maxLength={5}
                          onChange={handleZipCodeChange}
                          onKeyDown={handleKeyDown}
                          placeholder="Zip Code*"
                          value={zipCode}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  {message && (
                    <Row className={`${ForgotEmailStyle["margin-bottom-8"]}`}>
                      <Col
                        className={`${ForgotEmailStyle["account-margin-select"]}`}
                        lg={{ span: 8 }}
                        md={{ span: 8 }}
                        xl={{ span: 8 }}
                        xs={{ span: 24 }}
                      >
                        {message === "No Account Found" && <Text className={`${ForgotEmailStyle["error-msg"]}`}>Unable to locate policy.</Text>}
                        {message === 'Success' && <Text className={`${ForgotEmailStyle["success-msg"]}`}>{message}</Text>}
                        {message === 'Inactive' && <Text className={`${ForgotEmailStyle["error-msg"]}`}>
                        Your policy is inactive. Please call 800-535-2873 for assistance.
                        </Text>}
                        {!['Success', 'No Account Found', 'Inactive'].includes(message) && <Text className={`${ForgotEmailStyle["error-msg"]}`}>{message}</Text>}
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col
                      className={`${ForgotEmailStyle["account-margin"]}`}
                      lg={{ span: 6 }}
                      md={{ span: 8 }}
                      xl={{ span: 6 }}
                      xs={{ span: 24 }}
                    >
                      <Form.Item className={`${ForgotEmailStyle["btn-control"]} ${ForgotEmailStyle["text-center"]}`}>
                        <Button
                          className={`${ForgotEmailStyle["submit"]} ${ForgotEmailStyle["submit-form-button"]} ${ForgotEmailStyle["desktop-width-128"]}`}
                          disabled={validateEmailInputs()}
                          onClick={handleSubmit}
                        >
                          Submit
                        </Button>
                        {showSpinner && <Spin indicator={antIcon} style={{marginLeft: '2rem'}}/>}
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              )}
            </div>
            <Col lg={{ span: 12 }} md={{ span: 12 }} xl={{ span: 8 }} xs={{ span: 24 }}>
              {retrievedPolicyUser && !changeCurrentEmail && isMobile && (
                <h4 className={`${ForgotEmailStyle["sub-label"]} ${ForgotEmailStyle["email"]}`}>
                  Your Username (Email):&nbsp;&nbsp;&nbsp;
                  <span className={`${ForgotEmailStyle["email-address"]}`}>{retrievedPolicyUser.User.EmailAddress}</span>
                </h4>
              )}
              {retrievedPolicyUser && !changeCurrentEmail && !isMobile && (
                <h4 className={`${ForgotEmailStyle["sub-label"]} ${ForgotEmailStyle["email"]}`}>
                  Your Username (Email): <span className={`${ForgotEmailStyle["email-address"]}`}>{retrievedPolicyUser.User.EmailAddress}</span>
                </h4>
              )}
              {retrievedPolicyUser && !changeCurrentEmail && (
                <>
                  {' '}
                  <Row>
                    <Col
                      className={`${ForgotEmailStyle["account-margin"]}`}
                      lg={{ span: 24 }}
                      md={{ span: 24 }}
                      xl={{ span: 24 }}
                      xs={{ span: 24 }}
                    >
                      <Form.Item>
                        <Input
                          autoComplete="off"
                          className={`${ForgotEmailStyle["input-text"]} ${ForgotEmailStyle["dark-text"]}`}
                          disabled
                          placeholder="Email Address"
                          value={retrievedPolicyUser.User.EmailAddress}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className={`${ForgotEmailStyle["account-margin"]}`}
                      lg={{ span: 24 }}
                      md={{ span: 24 }}
                      xl={{ span: 24 }}
                      xs={{ span: 24 }}
                    >
                      <Form.Item>
                        <Input.Password
                          autoComplete="off"
                          className={`${ForgotEmailStyle["input-text"]}`}
                          iconRender={visible => (visible ? 'Hide' : 'Show')}
                          onChange={event => setPassword(event.target.value)}
                          onKeyDown={handleLoginKeyDown}
                          placeholder="Password*"
                          type="password"
                          value={password}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}
              {retrievedPolicyUser && !changeCurrentEmail && (loginApiResponseMessage === 'Not Found' || loginApiResponseMessage === 'Incorrect Password') && (
                <Text className={`${ForgotEmailStyle["error-msg"]}`}>Invalid password. <span onClick={() => Router.push("/my-account/forgot-password")} style={{ textDecoration: "underline", cursor: "pointer" }}>Forgot password?</span></Text>
              )}
              {retrievedPolicyUser && !changeCurrentEmail && loginApiResponseMessage === 'Inactive' && (
                <div className={`${ForgotEmailStyle["blue-message"]}`}>
                  Your account is inactive. Please call 800-535-2873 for assistance. If you would like to make a payment,&nbsp;
                  <a href={'https://' + getDomain('payments')} rel="noopener noreferrer" target="_blank">click here</a>
                </div>
              )}
              {retrievedPolicyUser && !changeCurrentEmail && (
                <Row justify="center">
                  <Col
                    className={`${ForgotEmailStyle["account-margin"]} ${ForgotEmailStyle["text-center"]}`}
                    lg={{ span: 8 }}
                    md={{ span: 8 }}
                    xl={{ span: 8 }}
                    xs={{ span: 24 }}
                  >
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      <Form.Item className={`${ForgotEmailStyle["btn-control"]}`}>
                          <Button className={`${ForgotEmailStyle["submit"]} ${ForgotEmailStyle["submit-form-button"]} ${ForgotEmailStyle["login"]}`} onClick={loginWithCurrentEmail}>
                            Log In
                          </Button>
                      </Form.Item>
                          {showSpinner && <Spin indicator={antIcon} style={{marginLeft:'2rem', marginTop:'24px'}}/>}
                     </div>
                  </Col>
                </Row>
              )}
              <Row justify="center">
                {retrievedPolicyUser && !changeCurrentEmail && (
                  <Col className={`${ForgotEmailStyle["account-margin"]}`}>
                    <Form.Item className={`${ForgotEmailStyle["btn-control"]}`}>
                      <Button
                        className={`${ForgotEmailStyle["submit"]} ${ForgotEmailStyle["submit-form-button"]}`}
                        onClick={() => {
                          scrollToTop()
                          setChangeCurrentEmail(!changeCurrentEmail)
                        }}
                      >
                        Change Username (Email)
                      </Button>
                    </Form.Item>
                  </Col>
                )}
              </Row>
            </Col>
            {changeCurrentEmail && !confirmCurrentEmail && (
              <div className={`${ForgotEmailStyle["security"]}`}>
                {isMobile && (
                  <Text className={`${ForgotEmailStyle["sub-text"]} ${ForgotEmailStyle["desktop-width-492"]}`}>Please answer one of the following questions:</Text>
                )}
                {!isMobile && <Text className={`${ForgotEmailStyle["sub-text"]}`}>Please answer one of the following questions:</Text>}
                <Row>
                  <Col className={`${ForgotEmailStyle["account-margin"]}`} xl={{ span: 24 }} xs={{ span: 24 }}>
                    {filteredSecurityQuestions && (
                      <Radio.Group onChange={handleRadioClick} value={selectedPwdOption}>
                        <Space direction="vertical">
                          {filteredSecurityQuestions.map(({ Code, Text }) => (
                            <Radio key={Code} value={Code}>
                              {Text}
                            </Radio>
                          ))}
                        </Space>
                      </Radio.Group>
                    )}
                  </Col>
                </Row>
                <Row className={`${ForgotEmailStyle["margin-top-12"]}`}>
                  <Col className={`${ForgotEmailStyle["account-margin"]}`} xl={{ span: 11 }} xs={{ span: 24 }}>
                    <Form.Item>
                      <Input
                        autoComplete="off"
                        className={`${ForgotEmailStyle["input-text"]} ${ForgotEmailStyle["desktop-width"]}`}
                        onChange={event => setSecurityAnswer(event.target.value)}
                        onKeyDown={handleSecurityKeyDown}
                        placeholder="Answer to security question selected above*"
                        value={securityAnswer}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                {securityQuestionMessage && (
                  <Row className={`${ForgotEmailStyle["margin-bottom-8"]}`}>
                    <Col
                      className={`${ForgotEmailStyle["account-margin-select"]}`}
                      lg={{ span: 8 }}
                      md={{ span: 8 }}
                      xl={{ span: 8 }}
                      xs={{ span: 24 }}
                    >
                      {securityQuestionMessage !== 'Success' && (
                        <Text className={`${ForgotEmailStyle["error-msg"]}`}>{securityQuestionMessage}</Text>
                      )}
                    </Col>
                  </Row>
                )}
                <Row className={`${ForgotEmailStyle["desktop-width"]}`} justify="center">
                  <Col className={`${ForgotEmailStyle["account-margin"]}`}>
                    <Form.Item className={`${ForgotEmailStyle["btn-control"]}`}>
                      <Button
                        className={`${ForgotEmailStyle["submit"]} ${ForgotEmailStyle["submit-form-button"]} ${ForgotEmailStyle["desktop-width-128"]}`}
                        disabled={disableSubmitButton}
                        onClick={handleChangeEmail}
                      >
                        Submit
                      </Button>
                      {showSpinner && <Spin indicator={antIcon} style={{marginLeft: '2rem'}}/>}
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            )}
            {confirmCurrentEmail && !showLogin && (
              <div>
                <h5>Change your email address.</h5>
                <Row>
                  <Col className={`${ForgotEmailStyle["account-margin"]}`} lg={{ span: 8 }} md={{ span: 8 }} xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item className="margin-bottom-9">
                      <Input
                        autoComplete="off"
                        className={`${ForgotEmailStyle["input-text"]}`}
                        onChange={event => setNewEmailAddress(event.target.value)}
                        onKeyDown={handleChangeEmailKeyDown}
                        placeholder="Email Address"
                        value={newEmailAddress}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col className={`${ForgotEmailStyle["account-margin"]}`} lg={{ span: 8 }} md={{ span: 8 }} xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item>
                      <Input
                        autoComplete="off"
                        className={`${ForgotEmailStyle["input-text"]}`}
                        onChange={event => setConfirmNewEmailAddress(event.target.value)}
                        onKeyDown={handleChangeEmailKeyDown}
                        placeholder="Confirm Email Address"
                        value={confirmNewEmailAddress}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                {emailConfirmationMessage && (
                  <Row className={`${ForgotEmailStyle["margin-bottom-8"]}`}>
                    <Col
                      className={`${ForgotEmailStyle["account-margin-select"]}`}
                      lg={{ span: 8 }}
                      md={{ span: 8 }}
                      xl={{ span: 8 }}
                      xs={{ span: 24 }}
                    >
                      {emailConfirmationMessage !== 'Success' && (
                        <Text className={`${ForgotEmailStyle["error-msg"]}`}>{emailConfirmationMessage}</Text>
                      )}
                      {emailConfirmationMessage === 'Success' && (
                        <Text className={`${ForgotEmailStyle["success-msg"]}`}>
                          Thank you. The email associated with your account has been updated.
                        </Text>
                      )}
                    </Col>
                  </Row>
                )}
                <Col className={`${ForgotEmailStyle["account-margin"]}`} lg={{ span: 8 }} md={{ span: 8 }} xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Row justify="center">
                    <Form.Item className={`${ForgotEmailStyle["btn-control"]}`}>
                      <Button
                        className={`${ForgotEmailStyle["submit"]} ${ForgotEmailStyle["submit-form-button"]} ${ForgotEmailStyle["confirm-email"]} ${ForgotEmailStyle["desktop-width-128"]}`}
                        disabled={validateEmailConfirmation()}
                        onClick={handleEmailConfirmation}
                      >
                        Submit
                      </Button>
                      {showSpinner && <Spin indicator={antIcon} style={{marginLeft: '2rem'}}/>}
                    </Form.Item>
                  </Row>
                </Col>
              </div>
            )}
            {confirmCurrentEmail && showLogin && (
              <div>
                <h5>Log in with your new email address.</h5>
                {isMobile && (
                  <h4 className={`${ForgotEmailStyle["sub-label"]} ${ForgotEmailStyle["email"]}`}>
                    Your Username (Email):&nbsp;&nbsp;&nbsp;
                    <span>{newEmailAddress}</span>
                  </h4>
                )}
                {!isMobile && (
                  <h4 className={`${ForgotEmailStyle["sub-label"]} ${ForgotEmailStyle["email"]}`}>
                    Your Username (Email): <span>{newEmailAddress}</span>
                  </h4>
                )}
                {emailConfirmationMessage === 'Success' && (
                  <Text className={`${ForgotEmailStyle["success-msg"]}`}>
                    Thank you. The email associated with your account has been updated.
                  </Text>
                )}
                <Row>
                  <Col className={`${ForgotEmailStyle["account-margin"]}`} lg={{ span: 8 }} md={{ span: 8 }} xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item>
                      <Input
                        autoComplete="off"
                        className={`${ForgotEmailStyle["input-text"]} ${ForgotEmailStyle["dark-text"]}`}
                        disabled
                        onKeyDown={handleLoginWithUpdatedEmailKeyDown}
                        placeholder="Email Address"
                        value={newEmailAddress}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col className={`${ForgotEmailStyle["account-margin"]}`} lg={{ span: 8 }} md={{ span: 8 }} xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item>
                      <Input.Password
                        autoComplete="off"
                        className={`${ForgotEmailStyle["input-text"]}`}
                        iconRender={visible => (visible ? 'Hide' : 'Show')}
                        onChange={event => setPassword(event.target.value)}
                        onKeyDown={handleLoginWithUpdatedEmailKeyDown}
                        placeholder="Password*"
                        type="password"
                        value={password}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                {loginApiResponseMessage === 'Not Found' && (
                  <Text className={`${ForgotEmailStyle["error-msg"]}`}>Invalid email address or password.</Text>
                )}
                <Row>
                  <Col className={`${ForgotEmailStyle["account-margin"]}`} style={{ width: '100%', textAlign: 'center' }}>
                    <Form.Item className={`${ForgotEmailStyle["btn-control"]}`}>
                      <Button className={`${ForgotEmailStyle["submit"]} ${ForgotEmailStyle["submit-form-button"]} ${ForgotEmailStyle["desktop-width-128"]}`} onClick={loginWithNewEmail}>
                        Log In
                      </Button>
                      {showSpinner && <Spin indicator={antIcon} style={{marginLeft: '2rem'}}/>}
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            )}
          </Card>
        </Row>
      </div>
    </>
  )
}

ForgotEmail.propTypes = {}

export default ForgotEmail
